import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import swal from 'sweetalert2';

@Component({
  selector: 'app-project-sprint',
  templateUrl: './project-sprint.component.html',
  styleUrls: ['./project-sprint.component.scss',
      "../../../../../../assets/sass/libs/datatables.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ProjectSprintComponent implements OnInit {



      @ViewChild(DatatableComponent) table: DatatableComponent;

      myForm : FormGroup

      searchVal = ''
      page = {
        pageNumber: 0,
        offset: 0,
        pageSize: 100,
        totalPages: 0
      };
      // row data
      public rows = [];
      public filterRows = [];
      public ColumnMode = ColumnMode;
      public limitRef = 100;
      selectedValue = ''
      isFilter: boolean = false
      // column header
      public taskView: boolean[] = [];
      public maincolumns = [
        { name: " Name", prop: "name" }
      ];
      public columns = [
        { name: " Name", prop: "name" },
        { name: "Email", prop: "email" },
        { name: "Designation", prop: "designation" },
        { name: "Phone", prop: "phone" },
        { name: "Actions", prop: "actions" },
      ];
    
      // private
      private tempData = [];
      imageUrl = environment.apiUrls.imageUrl;
      user_role: any
      activeTab =''
      @ViewChild('name') inputName;
      task_status_list =[]
      task_status_cat_id='643e806559b78b65557d7456'

      project_list =[]
      selected_check:any = []
      selected_project_id =null
      selected_check_name=''
      selectedEmp: string[] = [];
      empList =[]
      current_date: any
      time: any
      budget_val: any
      isAllSelected = false;
      selected_task_label = null
      taskLabelList = []
      task_label_catId = '643e7f6f59b78b65557d744a'
      selectedType =  'checklist'
      typeList = [
        { name: 'Ticket', id: 'ticket' },
        { name: 'Projects', id: 'projects' },
        { name: 'Leads', id: 'leads' },
        { name: 'Checklist', id: 'checklist' },
        { name: 'Message', id: 'message' }
      ]
      admin_notes_data:any
      public editing ={}
      task_id:any

      task_priority_catId = '643e7faf59b78b65557d744e'
      task_priority_List = []
      selected_task_priority = '643e823159b78b65557d74ab'
      task_stage_cat_id ='64ae4427e0a6ff2e7db7830e'
  task_stage_list = []
  stage_list =[]

      selected_user_id =''
      selected_priority_id=''
      selected_label_id =''
      selected_stage_id =''
  scheduleList = [
        { name: 'All', id: 'all' },
        { name: 'One Time', id: 'oneTime' },
        { name: 'Twice in a day', id: 'twice_in_a_day' },
        { name: 'Once in a day', id: 'once_in_a_day' },
        { name: 'Weekly', id: 'weekly' },
        { name: 'Bi-Weekly', id: 'bi_weekly' },
        { name: 'Monthly', id: 'monthly' },
        { name: 'Half-Yearly', id: 'half_yearly' },
        { name: 'Yearly', id: 'yearly' }
    
      ]
      selectedSchedule
      selectedSchedule_filter


      task_model={
        type_projects: [],
          to: [],
          title: '',
          body: '',
          due_date: '',
          priority: '',
          label: [],
          is_schedule: '',
          scheduleduration: '',
          is_mandatory: '',
          working_hours: '',
          budget: '',
          stage: '',
          status: '',
          notes: '',
          admin_notes: ''
      }

      isReadOnly : boolean = false;
      tableExpanded : boolean =false
      update_row_data: any
      row_id: any
      row_prop: any
      today_date: any
      isEditor: boolean = false
      isCollapsed = true;

      guideline_data:any
      list_type_id:any
      workon_id='644a5c52af0db342c32eeaf8'
      jobData:any
      payment_data=[]
      constructor(public apiService: ApiService,
        public toastr: ToastrService,private modalService: NgbModal,
        private spinner: NgxSpinnerService,private activerouter: ActivatedRoute,
        private route: Router, private formBuilder :FormBuilder,private cdr: ChangeDetectorRef) {
          this.selected_user_id ='all'
          this.selected_stage_id ='all'
          this.selected_label_id ='all'
          this.selected_priority_id ='all'
  
          this.getCheckList()

          this.activerouter.queryParams
          .subscribe((params: any) => {
            this.selected_project_id = params['id'];
            this.getFilterTask(this.selected_project_id,this.selected_priority_id,this.selected_user_id,this.selected_stage_id,this.selectedSchedule_filter)
          })

        this.user_role = JSON.parse(localStorage.getItem('user'))
        let setting_data = JSON.parse(localStorage.getItem('setting-record'))
        let key_data = setting_data.filter((item) => item.key == 'project_sprint_guideline')
        this.guideline_data = key_data[0]?._id
        this.getTaskLabelList()
        this.getTaskPriorityList()
        this.getTaskStageList()
        
      }
    
  ngOnInit(): void {

    this.getTaskStatusList()

    let date = new Date()
    this.today_date = moment(date).format();

        this.selected_user_id ='all'
        this.selected_stage_id ='all'
        this.selected_label_id ='all'
        this.selected_priority_id ='all'

        this.current_date = this.getCurrentDate()
        this.time = 1
        this.budget_val = 0
       
        this.myForm = this.formBuilder.group({
          title: ['', Validators.required],
          message: ['', Validators.required],
          type: ['', Validators.required],
          due_date: [this.current_date,],
          body: ['',],
          time: [this.time,],
          budget: [this.budget_val,],
          notes: ['',],
          admin_notes: ['',]
        });
       
        this.getAllEmployee()
        this.getUserById(this.user_role.id)
        setTimeout(()=>{                           
          this.activeEmployeeTab('open')
      }, 2000);
        
  }
   toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }
  getUserById(id) {
    this.apiService.getUserbyId(id).subscribe((res: any) => {
      if (res?.data?.user_filter?._id) {
        this.selected_user_id = res?.data?.user_filter?._id
      }
      else this.selected_user_id = 'all'
      if (res?.data?.task_priority?._id) {
        this.selected_priority_id = res?.data?.task_priority?._id
      }
      else this.selected_priority_id = 'all'
      if (res?.data?.task_schedule) {
        this.selectedSchedule_filter = res?.data?.task_schedule
      }
      else this.selectedSchedule_filter = 'all'
      if (res?.data?.task_stage?._id) {
        this.selected_stage_id = res?.data?.task_stage?._id
      }
      else this.selected_stage_id = 'all'

      this.getFilterTask(this.selected_project_id,this.selected_priority_id,this.selected_user_id,this.selected_stage_id,this.selectedSchedule_filter)
         
          
        })
      }
      ConfirmDelete(id: any,i) {
        swal.fire({
          title: 'Are you sure?',
          text: `You won't be able to revert this!`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2F8BE6',
          cancelButtonColor: '#F55252',
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-danger ml-1'
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.deleteTracker(id,i)
          } else if (result.dismiss === swal.DismissReason.cancel) {
            swal.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          }
        });
      }
      deleteTracker(id,i){
        if (id) {
          this.apiService.taskDelete(id).subscribe((res: any) => {
            if (res.statusCode === 200) {              
              swal.fire({
                icon: "success",
                title: 'Deleted!',
                text: 'Your imaginary file has been deleted.',
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
              this.setAndGetEmployeebyStatus()
            }
            else {
              swal.fire({
                title: 'Error',
                text: res.error,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
            }
          })
        }
        else {
          swal.fire({
            title: 'Error',
            text: 'something went wrong !!',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      }
      getChangeScheduleId(event) {
        this.selectedSchedule_filter = event.id
        let formData = new FormData()
        formData.append('task_schedule',this.selectedSchedule_filter)
        this.apiService.updateUser(this.user_role?.id,formData).subscribe((res:any)=>{})
        if(this.selected_user_id || this.selected_priority_id || this.selectedSchedule_filter || this.selected_stage_id){
          this.getFilterTask(this.selected_project_id,this.selected_priority_id,this.selected_user_id,this.selected_stage_id,this.selectedSchedule_filter)
        }
      }
      getUserId(event){
          this.selected_user_id
        let formData = new FormData()
        formData.append('user_filter',this.selected_user_id)
        this.apiService.updateUser(this.user_role?.id,formData).subscribe((res:any)=>{})
        if(this.selected_user_id || this.selected_priority_id || this.selectedSchedule_filter || this.selected_stage_id){
          this.getFilterTask(this.selected_project_id,this.selected_priority_id,this.selected_user_id,this.selected_stage_id,this.selectedSchedule_filter)
        }
      }
      getPriorityId(event){
          this.selected_priority_id 
        let formData = new FormData()
        formData.append('task_priority',this.selected_priority_id)
        this.apiService.updateUser(this.user_role?.id,formData).subscribe((res:any)=>{})
        if(this.selected_user_id  || this.selectedSchedule_filter || this.selected_stage_id){
          this.getFilterTask(this.selected_project_id,this.selected_priority_id,this.selected_user_id,this.selected_stage_id,this.selectedSchedule_filter)
        }
      }
      getLabelId(event){
          this.selected_label_id 
        let formData = new FormData()
        formData.append('task_label',this.selected_label_id)
        this.apiService.updateUser(this.user_role?.id,formData).subscribe((res:any)=>{})
        if(this.selected_user_id   || this.selected_priority_id || this.selected_stage_id){
          this.getFilterTask(this.selected_project_id,this.selected_priority_id,this.selected_user_id,this.selected_stage_id,this.selectedSchedule_filter)
        }
      }
      getStageId(event){
          this.selected_stage_id 
        let formData = new FormData()
        formData.append('task_stage',this.selected_stage_id)
        this.apiService.updateUser(this.user_role?.id,formData).subscribe((res:any)=>{})
        this.getFilterTask(this.selected_stage_id,this.selected_user_id,this.selected_priority_id,this.selectedSchedule_filter,this.selected_project_id)
      }

  getFilterTask(project_id,priority_id,user_id,stage_id, schedule_id) {
         this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      
    let status = this.task_status_list.find((item) => item?.name == this.activeTab);
       if(status){
        this.apiService.getTaskTypeProject(this.page.pageNumber+1,this.limitRef,this.selected_project_id,this.workon_id,priority_id,'',status._id,stage_id,schedule_id).subscribe((res:any)=>{
          this.rows = res?.data?.items
          this.page.totalPages = res?.data?.items?.length
          this.spinner.hide()
        })
       }
      }
      resetFilter(){
          this.selected_user_id ='all'
          this.selected_stage_id ='all'
          this.selected_label_id ='all'
        this.selected_priority_id = 'all'
        this.selectedSchedule_filter ='all'
          let formData = new FormData()
          formData.append('user_filter', this.selected_user_id)
          formData.append('task_stage',this.selected_stage_id )
          formData.append('task_priority',this.selected_label_id)
          formData.append('task_label',this.selected_priority_id)
          this.apiService.updateUser(this.user_role?.id,formData).subscribe((res:any)=>{})
          this.setAndGetEmployeebyStatus()
      }
      getCurrentDate(): string {
        const today = new Date();
        const year = today.getFullYear();
        const month = this.padNumber(today.getMonth() + 1);
        const day = this.padNumber(today.getDate());
        return `${year}-${month}-${day}`;
      }
      padNumber(number: number): string {
        return number < 10 ? `0${number}` : `${number}`;
      }

      getTaskStatusList() {
        this.apiService.getTagByTagCatgoryId(this.task_status_cat_id).subscribe((res: any) => {
          this.task_status_list = res?.data
          setTimeout(()=>{
            this.setAndGetEmployeebyStatus()
          },500)
        })
      }
      getCheckList(id?) {
        // getJobByWorkOnId
        this.apiService.getModelByWorkOnId( 1, 10,this.workon_id,'').subscribe((res: any) => {
          this.project_list = res?.data?.items
          if(!this.selected_project_id){
            this.selected_project_id = this.project_list[0]?._id
            this.selected_check_name = this.project_list[0]?.displayname
            
          }
          this.cdr.detectChanges()
        })
      }

  getCheckTypeId(event) {
        this.selected_project_id 
        this.spinner.show(undefined,
          {
            type: 'ball-triangle-path',
            size: 'medium',
            bdColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            fullScreen: true
          });
    let status = this.task_status_list.find((item) => item?.name == this.activeTab);
    this.apiService.getTaskTypeProject(this.page.pageNumber+1,this.limitRef,this.selected_project_id,this.workon_id,this.selected_priority_id,'',status._id,this.selected_stage_id,this.selectedSchedule_filter).subscribe((res:any)=>{
      this.spinner.hide()
          this.rows = res?.data?.items
        this.page.totalPages = res?.data?.totalCount
        })
    }
     
      activeEmployeeTab(tab) {
        const activetab = tab;
        this.activeTab = tab
        if (activetab !== '') {
          this.route.navigate(
            [],
            { relativeTo: this.activerouter, queryParams: { status: activetab,id:this.selected_project_id } }
          );
        }
      }
      setAndGetEmployeebyStatus() {
        this.activerouter.queryParams
          .subscribe((params: any) => {
            this.activeTab = params?.status;
            this.getFilterTask(this.selected_project_id,this.selected_priority_id,this.selected_user_id,this.selected_stage_id,this.selectedSchedule_filter)
          })
      }
     
      getTasksList() {
          this.spinner.show(undefined,
          {
            type: 'ball-triangle-path',
            size: 'medium',
            bdColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            fullScreen: true
          });
          let status = this.task_status_list.find((item) => item.name == this.activeTab);
          this.apiService.getTaskByStatusChecklistId(this.selected_project_id,status._id,this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
          this.spinner.hide();
          this.rows = res?.data?.items
          this.page.totalPages = res?.data?.totalCount
        })
      }
      pageChangeData(page: any) {
        this.spinner.show(undefined,
          {
            type: 'ball-triangle-path',
            size: 'medium',
            bdColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            fullScreen: true
          });
          let status = this.task_status_list.find((item) => item.name == this.activeTab);
          this.apiService.getTaskByStatus(status._id,this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
          this.rows = res.items
          this.page.totalPages = res.items.total
        })
      }
      getAllEmployee() {
        this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.empList = res.items
            let data ={name:'All',_id:'all'}
            this.empList.push(data)
          }
        })
      }
      openModalAddCheckList(content) {
        this.myForm.reset()
        this.task_model.title =''
        this.task_model.body = ''
        this.task_model.notes = ''
        this.task_model.admin_notes = ''
        this.selectedEmp = null
        this.selected_task_label = null
        this.task_id = ''
        
        this.budget_val = 0
         this.selectedSchedule = 'oneTime'
        const modalRef = this.modalService.open(content);
    
        modalRef.result.then((result) => {
          // console.log(`Modal closed with result: ${result}`);
        }, (reason) => {
          // console.log(`Modal dismissed with reason: ${reason}`);
        });
      }
      toggleSelectionEmp(item) {
        if (item.selected) {
          this.selectedEmp.push(item._id);
        } else {
          const index = this.selectedEmp.findIndex((selectedItem) => selectedItem === item);
          if (index !== -1) {
            this.selectedEmp.splice(index, 1);
          }
        }
        this.isAllSelected = this.empList.every((emp) => emp.selected);
      }
      onDropdownOpenEmp() {
        this.isAllSelected = this.empList.every((item) => item.selected);
      }
    
      onDropdownCloseEmp() {
        this.isAllSelected = this.empList.every((item) => item.selected);
      }
      getTaskLabelList() {
        this.apiService.getTagByTagCatgoryId(this.task_label_catId).subscribe((res: any) => {
          this.taskLabelList = res.data
          let data = {displayname:'All',_id:'all'}
          this.taskLabelList.push(data)
        })
      }
      getChangeTaskLabelId(event) {
        this.selected_task_label
      }
      getCheckListId(event){
        this.selected_check = this.selected_project_id
      }
      getTaskPriorityList() {
        this.apiService.getTagByTagCatgoryId(this.task_priority_catId).subscribe((res: any) => {
          this.task_priority_List = res.data
          let data ={displayname:'All',_id:'all'}
          this.task_priority_List.push(data)
        })
      }
      getChangeTaskPriority(id) {
        this.selected_task_priority = id
      }
      getTaskStageList() {
        this.apiService.getTagByTagCatgoryId(this.task_stage_cat_id).subscribe((res: any) => {
          this.task_stage_list = res.data
          let data ={displayname:'All',_id:'all'}
          this.task_stage_list.push(data)
          let dd = res.data
          this.stage_list = dd.filter(item=> item.displayname !=='All')
        })
      }
      getScheduleId(event){
        this.selectedSchedule = event.id
      }
      createTask() {
        this.selected_check = this.selected_project_id
        const uniqueSet = new Set(this.selectedEmp);
        const uniqueArray = Array.from(uniqueSet);
        let body = {
          title: this.myForm.value.title,
          body: this.task_model.body,
          due_date: this.myForm.value.due_date,
          working_hours: this.myForm.value.time,
          budget: this.myForm.value.budget,
          type_projects :  this.selected_check?this.selected_check:[this.selected_project_id],
          to: uniqueArray,
          priority: '643e823159b78b65557d74ab' ,
          label: this.selected_task_label=='all'||this.selected_task_label=='All'?[]:this.selected_task_label,
          is_schedule: 'oneTime',
          is_mandatory: 'no',
          stage: '64ae445ee0a6ff2e7db78317',
          status: '643e869259b78b65557d755a',
          notes : this.task_model.notes,
          admin_notes : this.task_model.admin_notes
        }
    
        this.apiService.createTask(body).subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.toastr.success(res.message)
            this.modalService.dismissAll()
            this.task_model.body = ''
            this.task_model.notes = ''
            this.task_model.admin_notes = ''
            this.setAndGetEmployeebyStatus()
          }
          else {
            this.toastr.error(res.error)
          }
        })
    
      }
      openModalNotes(content,data,id) {
        this.task_id = id
        this.admin_notes_data = data
        const modalOptions: NgbModalOptions = {
          backdrop: 'static', // Set backdrop to 'static' to prevent closing on clicking outside
          keyboard: false,    // Set keyboard to false to prevent closing on pressing Escape key
        };
        const modalRef = this.modalService.open(content,modalOptions);
        modalRef.result.then((result) => {
          // console.log(`Modal closed with result: ${result}`);
        }, (reason) => {
          // console.log(`Modal dismissed with reason: ${reason}`);
        });
      }
      updatePrority(taskId,priorityId){
        let body ={
          priority : priorityId,
        }
        this.apiService.updateTask(taskId,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('update successfully')
            this.setAndGetEmployeebyStatus()
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
      updateStatus(taskId,statusId){
      let body ={
        status :  statusId
      }
      this.apiService.updateTask(taskId,body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('update successfully')
          this.setAndGetEmployeebyStatus()

        }
        else{
          this.toastr.error(res.error)
        }
      })

      }
      openModalEmp(content,empData,id){
        this.task_id = id
          this.selectedEmp = empData.map(item => item?._id)
          const modalRef = this.modalService.open(content);
      
          modalRef.result.then((result) => {
            // console.log(`Modal closed with result: ${result}`);
          }, (reason) => {
            // console.log(`Modal dismissed with reason: ${reason}`);
          });
      }
      getEmpId(event){
        this.selectedEmp
      }
      updateAssignTo(){
        let body ={
          to: this.selectedEmp
        }
        this.apiService.updateTask(this.task_id,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('update successfully')
            this.modalService.dismissAll()
            this.setAndGetEmployeebyStatus()
  
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
      taskEdit(content,id){
        this.task_id = id

        const modalRef = this.modalService.open(content);
      
          modalRef.result.then((result) => {
            // console.log(`Modal closed with result: ${result}`);
          }, (reason) => {
            // console.log(`Modal dismissed with reason: ${reason}`);
          });

        this.apiService.getTaskById(id).subscribe((res:any)=>{
          console.log(res?.data[0])
          this.task_model.admin_notes = res?.data[0]?.admin_notes
          this.task_model.notes = res?.data[0]?.notes
          this.task_model.title = res?.data[0]?.title
          this.task_model.body = res?.data[0]?.body
          this.task_model.budget = res?.data[0]?.budget
          this.task_model.working_hours = res?.data[0]?.working_hours
          this.selectedEmp =  res?.data[0]?.to?.map(item => item._id)
          this.task_model.to = this.selectedEmp

          this.task_model.priority = res?.data[0]?.priority?._id
          this.task_model.stage  =  res?.data[0]?.stage?._id
          this.task_model.status  =  res?.data[0]?.status?.map(item=>item._id)
          this.task_model.due_date  =  res?.data[0]?.scheduleduration
          this.task_model.due_date = res?.data[0]?.due_date
          this.selectedSchedule  =  res?.data[0]?.is_schedule
          this.task_model.is_schedule =  this.selectedSchedule
          this.task_model.is_mandatory = res?.data[0]?.is_mandatory

          this.selected_check = res?.data[0]?.type_projects?.map(item=>item._id)
          this.task_model.type_projects  =  this.selected_check
          this.time =this.task_model.working_hours

         
        })
      }
      submit(){
        this.task_model.to = this.selectedEmp
        this.task_model.type_projects  =  this.selected_check
        this.task_model.label  =  this.selected_task_label=='all'||this.selected_task_label=='All'?[]:this.selected_task_label
        this.task_model.is_schedule = this.selectedSchedule

        this.apiService.updateTask(this.task_id,this.task_model).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('update successfull')
            this.selectedEmp = null
            this.selected_task_label = null
            this.task_id = ''
            this.myForm.reset()
            this.modalService.dismissAll()
            this.setAndGetEmployeebyStatus()
          }
          else this.toastr.error(res.error)
        })
  }
  toggleTable(): void {
    this.tableExpanded = !this.tableExpanded;
  }
  openModalUpdate(content, id, row_data, prop) {
    this.update_row_data = row_data
    if (row_data == null) {
      this.isReadOnly = true
    }
    else this.isReadOnly = false
    this.row_id = id
    this.row_prop = prop
    const modalOptions: NgbModalOptions = {
      size: 'lg' // 'sm', 'lg', or 'xl'
    };
      const modalRef = this.modalService.open(content,modalOptions);
      
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
      }, (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
  }
  inlineEditing(data) {
    this.update_row_data = data
  }
  submitEditData() {
        if(this.row_prop =='admin_notes'){
          let body ={
            admin_notes: this.update_row_data
          }
          this.apiService.updateTask(this.row_id,body).subscribe((res:any)=>{
            if(res?.statusCode === 200){
              this.toastr.success('update successfully')
              this.isEditor = false
              this.update_row_data =''
              this.modalService.dismissAll()
              this.setAndGetEmployeebyStatus()
            }
            else{
              this.toastr.error(res.error)
            }
          })
        }
        if(this.row_prop =='notes'){
        let body ={
          notes: this.update_row_data
          }
          
        this.apiService.updateTask(this.row_id,body).subscribe((res:any)=>{
          if(res?.statusCode === 200){
            this.isReadOnly= true
            this.toastr.success('update successfully')
            this.update_row_data =''
            this.modalService.dismissAll()
              this.setAndGetEmployeebyStatus()
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
      else if(this.row_prop =='body'){
        let body ={
          body: this.update_row_data
          }
        this.apiService.updateTask(this.row_id,body).subscribe((res:any)=>{
          if(res?.statusCode === 200){
            this.isReadOnly= true
            this.toastr.success('update successfully')
            this.update_row_data =''
            this.modalService.dismissAll()
              this.setAndGetEmployeebyStatus()
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }

  }
  setFocus($event) {
    $event.focus();
  }
  updateStage(id, stage_id) {
    this.row_id =id
    let body = {
      stage : stage_id
    }
     this.apiService.updateTask(this.row_id,body).subscribe((res:any)=>{
          if(res?.statusCode === 200){
            this.toastr.success('update successfully')
            this.modalService.dismissAll()
              this.setAndGetEmployeebyStatus()
          }
          else{
            this.toastr.error(res.error)
          }
        })
  }
  inlineAddupdateBody(data ,prop) {
    if (prop == 'body') {
      this.task_model.body =data
    }
    else if (prop == 'notes') {
      this.task_model.notes =data
    }
    else if(prop == 'admin_notes') {
      this.task_model.admin_notes =data
    }

  }
  
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }

  onSearch(searchTerm) {
    if (searchTerm.term !== '') {
      // getJobByWorkOnId
      this.apiService.getModelByWorkOnId(1,10,this.workon_id,searchTerm.term).subscribe((res:any)=>{
       this.project_list = res?.data?.items
      })
      
    }
  }
  copyItem(id){
    let url = `https://do.meander.software/task-view/${id}`
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('copy task url')
  }
     gotoEdit(){
        window.open(`/jobs/edit/${this.selected_project_id}`, '_blank');
      }
      getJobById(){
        this.spinner.show(undefined,
          {
            type: 'ball-triangle-path',
            size: 'medium',
            bdColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            fullScreen: true
          });
        this.apiService.getJobsById(this.selected_project_id).subscribe((res:any)=>{
          if(res.statusCode == 200){
            this.spinner.hide()
            for(let item of res?.data){
              this.jobData=item
            }
          }
        })
      }
      getPaymentByJobId(){
        this.spinner.show(undefined,
          {
            type: 'ball-triangle-path',
            size: 'medium',
            bdColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            fullScreen: true
          });
        this.apiService.getPaymentReportsById(this.selected_project_id).subscribe((res:any)=>{
          if(res.statusCode == 200){
            this.spinner.hide()
            this.payment_data = res.data
            // getPaymentReportsById  getTransactionByJobId
          }
        })
      }
      openViewModal(content){
        this.getPaymentByJobId()
        this.getJobById()
        const modalOptions: NgbModalOptions = {
          size: 'lg' // 'sm', 'lg', or 'xl'
        };
          const modalRef = this.modalService.open(content,modalOptions);
          
          modalRef.result.then((result) => {
            this.jobData =null
            this.payment_data =null
            // console.log(`Modal closed with result: ${result}`);
          }, (reason) => {
            this.jobData =null
            this.payment_data =null
            // console.log(`Modal dismissed with reason: ${reason}`);
          });
      }

}

    
